// require('./env1')
// console.log("____________________ ",process.argv);
// process.exit();
const local = Object.seal(require('./local')); //local
const dev = Object.seal(require('./dev')); // dev
const prod = Object.seal(require('./prod')); //prod
 module.exports = prod;
//module.exports = dev;


// WEBPACK FOOTER //
// ./src/env/index.js